import { useSelector } from 'react-redux';
import { RootState } from '../redux/store';
import { translations } from '../constant/translations';
// import { translations } from '../locales/translations';

export const useTranslation = () => {
    const language = useSelector((state: RootState) => state.language.language);

    // Helper function to get translation
    const t = (section: keyof typeof translations, key: string): string => {
        const translationSection = translations[section];
        if (!translationSection) return key;

        const langData = translationSection[language];
        return (langData as any)?.[key] || key;
    };

    return { t, language };
};
